/* The native details/summary remains keyboard operable without JavaScript.
   Close its menu on outside click or Escape to avoid covering maker controls. */
document.addEventListener('click', (event) => {
  document.querySelectorAll('[data-ops-maker-switch][open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const openMenu = document.querySelector('[data-ops-maker-switch][open]');
  if (!openMenu) return;
  openMenu.open = false;
  openMenu.querySelector('summary')?.focus();
  event.preventDefault();
});
